module.exports = __webpack_public_path__ + "img/unknown.d34861a3.png";